import Vue from "vue";

import RetrievePassword from "./RetrievePassword.vue";

export function load() {
    const selector = "retrieve-password";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(RetrievePassword, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
